import React, { useEffect, useMemo, useState } from "react"
import { Typography } from "@fullscreendigital/carrefour-dex-fe"
import { Table } from "components/core-ui/Table"
import { useNotification } from "../../../../hooks"
import { formatErrorMessage } from "utils/formatting"
import { useLocation, useParams } from "react-router-dom"
import s from "../../../shop-reception/commonStyles.modules.scss"

import { fetchCashbackProgressDetails } from "../../api"
import { CashbackTransaction } from "../../interfaces"
import { columns, toTableRowItems, toolbarActions, filters } from "./helpers"

const EmployeeDetails: React.FC = () => {
  const { showNotification } = useNotification()
  const location = useLocation()

  const { id: afgCardId } = useParams<{ id: string }>()

  const searchParams = new URLSearchParams(location.search)
  const year = Number(searchParams.get("year"))
  const month = Number(searchParams.get("month"))

  const [isLoading, setIsLoading] = useState(false)
  const [shouldRefreshData, setShouldRefreshData] = useState(false)

  const [tableItems, setTableItems] = useState<any[]>([])
  const [totalCount, setTotalCount] = useState<number>(0)
  const [lastLoadedRows, setLastLoadedRows] = useState<CashbackTransaction[]>([])

  const fetchData = async ({ order, orderBy, tableFilters }) => {
    if (!afgCardId || !year || !month) return

    setIsLoading(true)
    try {
      const res = await fetchCashbackProgressDetails({
        afgCardId,
        year: Number(year),
        month: Number(month),
        order,
        orderBy,
        tableFilters
      })

      const list = res.transactions ?? []
      setLastLoadedRows(list)
      setTableItems(toTableRowItems(list))
      setTotalCount(list.length)
    } catch (error) {
      showNotification({
        type: "error",
        message: `A apărut o eroare la încărcarea detaliilor. ${formatErrorMessage(error)}`,
      })
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (afgCardId && year && month) setShouldRefreshData(true)
  }, [afgCardId, year, month])

  const toolbar = useMemo(
    () => toolbarActions({ onRefresh: () => setShouldRefreshData(true), isLoading }),
    [isLoading]
  )

  return (
    <div className={s.mainContainer}>
      <div style={{ textAlign: "center" }}>
        <Typography variant="medium" component="h2">
          Detalii cashback — card {afgCardId} ({year}-{String(month).padStart(2, "0")})
        </Typography>
      </div>

      <div style={{ marginTop: 24 }}>
        <h3>Tranzacții</h3>

        <Table
          hideCheckbox
          columns={columns()}
          items={tableItems}
          fetchData={fetchData}
          isLoading={isLoading}
          totalCount={totalCount}
          shouldRefreshData={shouldRefreshData}
          setShouldRefreshData={setShouldRefreshData}
          toolbarActions={toolbar}
          filters={filters()}
          filtersButtonLabel="Filtre"
          filtersLabel="Filtre"
          appliedFiltersLabel="Filtre aplicate"
          cancelFiltersButtonLabel="Anuleaza"
          applyFiltersButtonLabel="Aplica"
          rowActionsWidth="0px"
          disablePagination
        />

        {!isLoading && lastLoadedRows.length === 0 && (
          <div style={{ marginTop: 12, textAlign: "center", color: "#666" }}>
            Nu există tranzacții pentru perioada selectată.
          </div>
        )}
      </div>
    </div>
  )
}

export default EmployeeDetails
